import appIcon from 'assets/brand/marco-app-icon.png';
import symbol from 'assets/brand/marco-symbol.png';
import { cn } from 'shared/utils/cn';

type LogoSize = 'sm' | 'md' | 'lg';

const ICON_SIZE: Record<LogoSize, string> = { sm: 'h-7 w-7', md: 'h-8 w-8', lg: 'h-12 w-12' };
const WORDMARK_SIZE: Record<LogoSize, string> = { sm: 'text-base', md: 'text-lg', lg: 'text-2xl' };

interface BrandLogoProps {
  size?: LogoSize;
  /** 'icone': M branco no quadrado laranja (padrão). 'simbolo': M laranja sem fundo. */
  variant?: 'icone' | 'simbolo';
  /** Mostra o nome "Marcô" ao lado do ícone. */
  wordmark?: boolean;
  className?: string;
}

// Logo oficial da Marcô. Use sempre este componente em vez de recriar a marca na tela.
export function BrandLogo({ size = 'md', variant = 'icone', wordmark = true, className }: BrandLogoProps) {
  return (
    <span className={cn('flex items-center gap-2.5', className)}>
      <img
        src={variant === 'icone' ? appIcon : symbol}
        alt={wordmark ? '' : 'Marcô'}
        className={cn(ICON_SIZE[size], 'flex-shrink-0 object-contain')}
        draggable={false}
      />
      {wordmark && <span className={cn('font-heading font-bold text-ink', WORDMARK_SIZE[size])}>Marcô</span>}
    </span>
  );
}
